module.exports = __webpack_public_path__ + "media/images/journey-day02-cd5b911e67285c3d0c511b2ec3c1bcd2.jpg";